import React, { FC, useCallback } from 'react';
import { Button } from 'antd';
import { useConnection } from '../../connection/Application';
import Image from 'next/image';
import linkedIn from '../../public/linkedin.png';
import { useRouter } from 'next/router';
import { useAuth } from '../../page-components/auth/AuthContext';
import Utils from '../../utils/Utils';

export const LinkedinAuthButton: FC = () => {
  const connection = useConnection();
  const router = useRouter();
  const { setLoading } = useAuth();
  const linkedInAuth = useCallback(() => {
    Utils.sendGtmCustomEvent('link_click', { click_text: 'Linkedin Auth' });
    setLoading(true);
    connection
      .get('auth/linkedIn')
      .then((res) => {
        router.push(res.url);
      })
      .catch(() => console.log('Error in Login with Linkedin'))
      .finally(() => setLoading(false));
  }, [connection, router, setLoading]);

  return (
    <Button
      className="socialauth"
      shape="circle"
      onClick={linkedInAuth}
      id={'btn-linked-in-login'}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 58,
        height: 58,
        background: '#F6F6F6',
      }}>
      <Image src={linkedIn} width={30} height={30} alt={'Linkedin Logo'} />
    </Button>
  );
};
